export default {
  disconnected: 'disconnected',
  connected: 'connected',
  reconnecting: 'reconnecting',
  ended: 'ended',
};
